import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { AdminPackagesStateData } from "@/types/catalog"

export type AdminPackagesState = {
  data: AdminPackagesStateData
  error: string | null
}

export const adminPackagesInitialState: AdminPackagesState = {
  data: {
    packages: [],
    pagination: {
      pageNumber: 1,
      pageSize: 10,
      totalElements: 0,
      totalPages: 0,
    },
  },
  error: null,
}

const slice = createSlice({
  name: "adminPackages",
  initialState: adminPackagesInitialState,
  reducers: {
    setAdminPackagesAction(state, { payload }: PayloadAction<AdminPackagesStateData>) {
      state.data = payload
      state.error = null
    },
    setAdminPackagesErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload
    },
  },
})

export const { setAdminPackagesAction, setAdminPackagesErrorAction } = slice.actions
export default slice.reducer
